import React from 'react'

import { ScheduledCommunicationTypeList } from '@/types/ScheduledCommunicationType'

type Props = {
  scheduledCommunicationType: ScheduledCommunicationTypeList
}

const MobileScheduledCommunicationTypeCard = ({ scheduledCommunicationType }: Props) => {
  return (
    <div className="mb-4 w-full overflow-hidden rounded-md border border-border-primary p-4 shadow-md">
      <div className="mb-2 flex justify-between">
        <p className="flex-none text-sm text-grey-500">Scheduled Communication Type ID</p>
        <p className="ml-3 flex-1 text-right text-sm" style={{ fontWeight: 'bold' }}>
          {scheduledCommunicationType.id}
        </p>
      </div>
      <div className="flex justify-between">
        <p className="flex-none text-sm text-grey-500">Description</p>
        <p className="ml-3 flex-1 text-right text-sm">{scheduledCommunicationType.description}</p>
      </div>
    </div>
  )
}
export default MobileScheduledCommunicationTypeCard
